<template>
    <TasksListComponent :title="$t('taskViews.agreed')" :apiUrl="apiUrl" :showFilters="false" />
</template>
  
<script>
import TasksListComponent from '@/components/TasksListComponent.vue';

export default {
    name: 'TasksAgreedListView',
    components: {
        TasksListComponent
    },
    computed: {
        apiUrl() {
            const baseApiUrl = 'tasks/';
            const params = new URLSearchParams({
                finished: '0',
                agreed: '1',
                users: this.currentUser.id,
                sort_by: 'estimated_date',
                sort_order: 'asc'
            });
            return `${baseApiUrl}?${params.toString()}`;
        },
        currentUser() {
            const user = localStorage.getItem('user');
            return user ? JSON.parse(user) : null;
        }
    }
};
</script>
  